export const MEMORY_GAME_PREFERENCE_KEY = "vocabularium_memory_game_mode";
export const MEMORY_GAME_PREFERENCE_CHANGE_EVENT = "memoryGamePreferenceChanged";

export const MEMORY_GAME_MODES = {
  PROPOSE: "propose",
  VOCAB_ONLY: "vocab-only",
};

export const MEMORY_GAME_MODE_OPTIONS = [
  {
    value: MEMORY_GAME_MODES.PROPOSE,
    label: "Proposer le jeu de mémoire en fin de partie",
  },
  {
    value: MEMORY_GAME_MODES.VOCAB_ONLY,
    label: "Jeux de vocabulaire uniquement",
  },
];

const VALID_MODES = new Set(Object.values(MEMORY_GAME_MODES));

export function readMemoryGamePreference() {
  try {
    const raw = localStorage.getItem(MEMORY_GAME_PREFERENCE_KEY);
    if (raw && VALID_MODES.has(raw)) return raw;
  } catch {
    // ignore
  }
  return MEMORY_GAME_MODES.PROPOSE;
}

export function writeMemoryGamePreference(mode) {
  const value = VALID_MODES.has(mode) ? mode : MEMORY_GAME_MODES.PROPOSE;

  try {
    localStorage.setItem(MEMORY_GAME_PREFERENCE_KEY, value);
  } catch {
    // ignore
  }

  window.dispatchEvent(
    new CustomEvent(MEMORY_GAME_PREFERENCE_CHANGE_EVENT, {
      detail: { mode: value },
    })
  );
}

export function subscribeMemoryGamePreference(onChange) {
  const handler = (event) => {
    onChange(event.detail?.mode ?? readMemoryGamePreference());
  };

  window.addEventListener(MEMORY_GAME_PREFERENCE_CHANGE_EVENT, handler);
  return () => window.removeEventListener(MEMORY_GAME_PREFERENCE_CHANGE_EVENT, handler);
}

export function shouldProposeMemoryGame() {
  return readMemoryGamePreference() === MEMORY_GAME_MODES.PROPOSE;
}
